import { render, staticRenderFns } from "./subjects.vue?vue&type=template&id=d680436e&scoped=true&"
import script from "./subjects.vue?vue&type=script&lang=js&"
export * from "./subjects.vue?vue&type=script&lang=js&"
import style0 from "./subjects.vue?vue&type=style&index=0&id=d680436e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d680436e",
  null
  
)

export default component.exports